import { useGetUserFirstNameWithFallback, useGetUserFullNameWithFallback } from '@pba/react-utils';
import { isMessagePlaceholder } from 'models';
import { useMemo } from 'react';
import { useFormatTime } from 'ui';

import type { VirtualChatMessageRow } from '../../../types';

type P = {
  row: VirtualChatMessageRow;
};

export const useChatMessageRow = ({ row }: P) => {
  const formatTime = useFormatTime();
  const getUserFirstNameWithFallback = useGetUserFirstNameWithFallback();
  const getUserFullNameWithFallback = useGetUserFullNameWithFallback();
  const participant = row.group.author?.participant;

  return useMemo(() => {
    const formattedTime = formatTime({ timeInfo: { dateTime: row.message.createdAt } });
    const authorName =
      row.direction === 'incoming' && participant ? getUserFirstNameWithFallback(participant) : undefined;
    const authorFullName =
      row.direction === 'incoming' && participant ? getUserFullNameWithFallback(participant) : undefined;
    const deliveryStatus = isMessagePlaceholder(row.message) ? row.message.status : undefined;

    return { authorFullName, authorName, deliveryStatus, formattedTime };
  }, [formatTime, getUserFirstNameWithFallback, getUserFullNameWithFallback, participant, row.direction, row.message]);
};
